<template>
  <b-modal :active="true" :on-cancel="handleCancel" custom-class="premium-modal"
    has-modal-card trap-focus>
    <div class="card">
      <div class="card-content">
        <h3 class="title is-5">
          {{ title }} is a <span class="has-text-primary">premium</span> feature.
          Please upgrade to continue.
        </h3>
      </div>
      <div class="card-content">
        <premium-features />
      </div>
      <div class="card-content">
        <router-link
          class="button is-primary is-medium"
          :to="{ name: 'Upgrade' }">
          Subscribe Now!
        </router-link>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PremiumFeatures from '@/components/PremiumFeatures.vue'

export default {
  name: 'PremiumModal',
  props: ['feature', 'onClose'],
  components: {
    PremiumFeatures
  },
  computed: {
    title() {
      return this.feature || this.$route.name
    }
  },
  methods: {
    handleCancel() {
      if (this.onClose) {
        this.onClose()
      } else {
        this.$router.push('/home')
      }
    }
  }
};
</script>

<style lang="scss">
.premium-modal {
  .modal-background {
    background-color: rgba(10, 10, 10, 0.5);
  }
}
</style>
